<template>
  <div class="informatives">
    <div class="informatives__header">
      <p>Fique por dentro</p>
      <router-link tag="a" :to="{ name: 'club.informatives' }">
        VEJA TODAS AS NOVIDADES
        <b-icon icon="chevron-double-right"></b-icon>
      </router-link>
    </div>
    <div class="container-md">
      <div class="row justify-content-md-center">
        <div
          v-for="informative in informatives"
          :key="`informative-${informative.id}`"
          class="col-xl-4 col-sm-6"
        >
          <informative-card
            @click="viewInformative(informative)"
            class="informatives-card"
            :informative="informative"
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <b-pagination
            :range-before="1"
            :range-after="1"
            aria-next-label="Próxima página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página atual"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InformativeService from '@/services/informative.service';
import InformativeCard from '@/components/Informative/InformativeCard.vue';

export default {
  name: 'informatives',
  components: {
    InformativeCard,
  },
  data: () => {
    return {
      isLoading: true,
      informatives: [],
    };
  },
  methods: {
    viewInformative(informative) {
      this.$router.push({
        name: 'club.informatives.view',
        params: { id: informative.id },
      });
    },
  },
  mounted() {
    InformativeService.get()
      .then((response) => {
        const { data: informatives } = response.data;
        this.informatives = informatives.slice(0, 3);
      })
      .finally(() => (this.isLoading = false));
  },
};
</script>

<style lang="scss" scoped>
.informatives {
  margin: 0 15vw;
  .informatives-card {
    transition: 200ms ease-in-out;
    cursor: pointer;

    &:hover {
      transform: scale(1.05);
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      color: var(--color-secondary);
      font-weight: bold;
      font-size: 1.8em;
      text-align: center;
    }

    a {
      position: absolute;
      right: 15vw;

      display: flex;
      align-items: center;
      font-size: 0.9em;
      font-weight: 500;
      color: var(--color-primary);

      .icon {
        margin-left: 12px;
        color: var(--text-color);
      }
    }
  }

  &__carousel {
    margin-top: 32px;
  }

  &__items {
    display: flex;
    margin-top: 32px;

    .item {
      flex-grow: 1;
      flex-basis: 0;
      background: #fff;
      border: 1px solid var(--color-primary);
      border-radius: 12px;
      overflow: hidden;
      transition: 200ms ease-in-out;
      cursor: pointer;

      &:hover {
        transform: scale(1.05);
      }

      &:not(:last-child) {
        margin-right: 24px;
      }

      &__header {
        background: var(--color-primary);
        padding: 12px;

        .title {
          color: #fff;
          font-size: 0.9em;
          font-weight: bold;
          margin: 0;
          text-transform: uppercase;
        }

        .date {
          color: #fff;
          font-size: 0.8em;
        }
      }

      &__description {
        padding: 16px;
        font-size: 0.8em;
      }
    }
  }
}

@media (max-width: 992px) {
  .informatives {
    &__header {
      flex-direction: column;

      a {
        position: static;
      }
    }
  }
}
</style>
